module.exports = __webpack_public_path__ + "img/ks_yufu.77ae5ef2.png";